<app-parameter-card class="text-input-card" [title]="title">
  <div class="pills top">Saisissez votre texte</div>
  <mat-form-field>
  <input #textInput type="text" placeholder="Ex. BORN TO RIDE"
         [value]="parameterData.value" matInput>
  </mat-form-field>
</app-parameter-card>
